// Unified version name display format: `app - versionName(code)`.
// apps comes from useApps(); falls back to `versionName(code)` when the app is missing.
export function versionLabel(
  version:
    | {
        pid?: string | null;
        versionName?: string | null;
        versionCode?: string | null;
      }
    | null
    | undefined,
  apps?: { id?: string | number; name?: string }[],
): string {
  if (!version) return "";
  const app = apps?.find((a) => a.id === version.pid);
  const code = version.versionCode ? `(${version.versionCode})` : "";
  return `${app ? `${app.name} - ` : ""}${version.versionName ?? ""}${code}`;
}
